import { useContext, useState, useRef, useEffect, useCallback } from 'react';
import { LanguageContext } from '../components/LanguageContext';
import catalogData from '../locales/catalogData.json';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../styles/CatalogBook.css';

export default function Catalog() {
    const { language } = useContext(LanguageContext);
    const items = catalogData[language] || catalogData['ru'];

    const videoSources = ['/videos/555.mp4', '/videos/55.mp4'];
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showControls, setShowControls] = useState(true);
    const videoRef = useRef(null);
    const hideTimeout = useRef(null);

    const location = useLocation();

    // scroll to top on mount (for mobile only)
    useEffect(() => {
        if (window.innerWidth <= 768) {
            window.scrollTo({ top: 0, behavior: 'instant' });
        }
    }, [location]);

    const prevVideo = useCallback(() => {
        setShowControls(true);
        setCurrentIndex(idx => (idx - 1 + videoSources.length) % videoSources.length);
    }, [videoSources.length]);

    const nextVideo = useCallback(() => {
        setShowControls(true);
        setCurrentIndex(idx => (idx + 1) % videoSources.length);
    }, [videoSources.length]);

    useEffect(() => {
        const videoElement = videoRef.current;
        if (!videoElement) return;

        const showAndHideControls = () => {
            setShowControls(true);
            if (hideTimeout.current) clearTimeout(hideTimeout.current);
            hideTimeout.current = setTimeout(() => setShowControls(false), 3000);
        };

        videoElement.addEventListener('play', showAndHideControls);
        videoElement.addEventListener('mousemove', showAndHideControls);
        videoElement.addEventListener('touchstart', showAndHideControls);
        videoElement.addEventListener('ended', nextVideo);

        return () => {
            videoElement.removeEventListener('play', showAndHideControls);
            videoElement.removeEventListener('mousemove', showAndHideControls);
            videoElement.removeEventListener('touchstart', showAndHideControls);
            videoElement.removeEventListener('ended', nextVideo);
            if (hideTimeout.current) clearTimeout(hideTimeout.current);
        };
    }, [nextVideo, currentIndex]);

    return (
        <section className="catalog-container">
            <h2 className="catalog-title">
                {language === 'kg' ? 'Товарлар каталогу' : 'Каталог товаров'}
            </h2>

            <div
                className="video-carousel"
                style={{ maxWidth: '600px', margin: '0 auto 3rem', width: '100%', position: 'relative' }}
            >
                <button
                    className={`carousel-btn prev-btn ${!showControls ? 'hidden' : ''}`}
                    onClick={prevVideo}
                >
                    <FaChevronLeft />
                </button>
                <video
                    ref={videoRef}
                    src={videoSources[currentIndex]}
                    autoPlay
                    muted
                    playsInline
                    preload="auto"
                    controls
                    controlsList="nodownload"
                    disablePictureInPicture
                    className="carousel-video"
                    style={{ width: '100%' }}
                />
                <button
                    className={`carousel-btn next-btn ${!showControls ? 'hidden' : ''}`}
                    onClick={nextVideo}
                >
                    <FaChevronRight />
                </button>
            </div>

            <div className="catalog-grid">
                {items.map(item => (
                    <div key={item.id} className="catalog-card">
                        <div className="catalog-image-wrapper">
                            <img
                                src={item.image}
                                alt={item.model}
                                className="catalog-image"
                            />
                        </div>
                        <h3>{item.model}</h3>
                        <p>{item.shortDescription}</p>
                        {item.pdf ? (
                            <a
                                href={item.pdf}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-details"
                            >
                                {language === 'kg' ? 'Толугураак' : 'Подробнее'}
                            </a>
                        ) : (
                            <Link to={`/catalog/${item.id}`} className="btn-details">
                                {language === 'kg' ? 'Толугураак' : 'Подробнее'}
                            </Link>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}
